import { CSSProperties } from 'react';
import styled, { useTheme } from 'styled-components';

export type InputUnderlineType = {
  placeHolder: string;
  placeHolderStyle?: CSSProperties;
  value: string;
  onChange: (text: string) => void;
  style?: React.CSSProperties;
  onEnter?: (text: string) => void;
};

export const InputUnderline = (props: InputUnderlineType) => {
  const { placeHolder, value, onChange, onEnter, placeHolderStyle } = props;

  const theme = useTheme();

  const defaultStyle: React.CSSProperties = {
    border: 'none',
    flex: 1,
    outline: 'none',
    height: '30px',
    fontWeight: 500,
    fontSize: '15px',
    borderBottomWidth: '1px',
    borderBottomColor: theme.colors.brightNavy,
    borderBottomStyle: 'solid',
    backgroundColor: 'transparent',
  };

  const mergedStyle = { ...defaultStyle, ...(props.style || {}) };

  return (
    <Input
      $placeHolderStyle={placeHolderStyle}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeHolder}
      style={{ ...mergedStyle }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && onEnter) {
          onEnter(value);
        }
      }}
    />
  );
};

const Input = styled.input<{ $placeHolderStyle?: CSSProperties }>`
  &::placeholder {
    ${({ $placeHolderStyle }) => $placeHolderStyle && { ...$placeHolderStyle }};
  }
`;
